module.exports = __webpack_public_path__ + "media/assets/img/company/logo Arteredi-40c189e01998ee1cf924250a658ca357.png";